import Container from "./Container";
import "./Footer.css";
import { useState, useEffect } from "react";

export default function Footer() {
  const year = new Date().getFullYear();
  const [visitorCount, setVisitorCount] = useState(0);
  const [email, setEmail] = useState("");

  useEffect(() => {
    // Get current count from localStorage
    const currentCount = parseInt(localStorage.getItem('visitorCount') || '0');
    const newCount = currentCount + 1;
    
    // Update localStorage and state
    localStorage.setItem('visitorCount', newCount.toString());
    setVisitorCount(newCount);
  }, []);

  const handleScrollToTop = (e) => {
    e.preventDefault();
    // Use Locomotive Scroll instance if available, otherwise fallback
    const scrollInstance = window.locomotiveScroll;
    if (scrollInstance && typeof scrollInstance.scrollTo === 'function') {
      scrollInstance.scrollTo('top');
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    // Handle newsletter subscription
    console.log('Newsletter subscription:', email);
    setEmail('');
  };

  return (
    <footer className="ft" aria-label="Site footer">
      {/* Decorative background */}
      <div className="ft__bg" aria-hidden="true" />
      
      {/* Enhanced background elements */}
      <div className="ft__particles" aria-hidden="true" />
      <div className="ft__gradient" aria-hidden="true" />

      <Container>
        <div className="ft__top">
          {/* Brand / About */}
          <div className="ftBrand">
            <div className="ftBrand__header">
              <a className="ftBrand__line" href="/" aria-label="Augutsya home">
                <img
                  className="ftBrand__logo"
                  src="/atpwhite.png"
                  alt="Augutsya"
                  width="160"
                  height="48"
                  loading="lazy"
                />
              </a>
              <div className="ftBrand__badge">
                <span className="badge-icon">⭐</span>
                <span className="badge-text">Excellence</span>
              </div>
            </div>

            <p className="ftBrand__tag">
              Your search for techno-commercial consultant ends here
            </p>

            <div className="ftSocial">
              <a href="#" className="social-link" aria-label="Facebook">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a href="#" className="social-link" aria-label="Twitter">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053-5.676 11.945-17.639 6.268-26.724a10.016 10.016 0 00-2.856-5.715z"/>
                </svg>
              </a>
              <a href="#" className="social-link" aria-label="LinkedIn">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Links column 1 */}
          <nav className="ftLinks" aria-label="Footer links">
            <h4 className="ftLinks__title">Services</h4>
            <ul className="ftLinks__list">
              <li>
                <a href="/services/" className="ftLinks__item">
                  <span className="chev" aria-hidden="true">›</span> Web Development
                </a>
              </li>
              <li>
                <a href="/services/" className="ftLinks__item">
                  <span className="chev" aria-hidden="true">›</span> Mobile Apps
                </a>
              </li>
              <li>
                <a href="/services/" className="ftLinks__item">
                  <span className="chev" aria-hidden="true">›</span> Cloud Solutions
                </a>
              </li>
              <li>
                <a href="/services/" className="ftLinks__item">
                  <span className="chev" aria-hidden="true">›</span> IT Consulting
                </a>
              </li>
            </ul>
          </nav>

          {/* Links column 2 */}
          <nav className="ftLinks ftLinks--right" aria-label="Footer links secondary">
            <h4 className="ftLinks__title">Company</h4>
            <ul className="ftLinks__list">
              <li>
                <a href="/about-us/" className="ftLinks__item">
                  <span className="chev" aria-hidden="true">›</span> About Us
                </a>
              </li>
              <li>
                <a href="/contact-us/" className="ftLinks__item">
                  <span className="chev" aria-hidden="true">›</span> Contact
                </a>
              </li>
              <li>
                <a href="/privacy-policy/" className="ftLinks__item">
                  <span className="chev" aria-hidden="true">›</span> Privacy Policy
                </a>
              </li>
              <li>
                <a href="/terms/" className="ftLinks__item">
                  <span className="chev" aria-hidden="true">›</span> Terms
                </a>
              </li>
            </ul>
          </nav>

          {/* Newsletter */}
          <div className="ftNewsletter">
            <h4 className="ftLinks__title">Stay Updated</h4>
            <p className="ftNewsletter__desc">Get the latest updates and offers</p>
            <form className="ftNewsletter__form" onSubmit={handleNewsletterSubmit}>
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="ftNewsletter__input"
                required
              />
              <button type="submit" className="ftNewsletter__btn">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 2L11 13M22 2l-7 20-4-9-9 9"/>
                </svg>
              </button>
            </form>
          </div>
        </div>
      </Container>

      <div className="ft__divider" role="presentation" />

      {/* Bottom bar */}
      <div className="ft__bottom">
        <Container>
          <div className="ftBottom__wrap">
            <div className="ftBottom__left">
              <p className="ftCopy">
                © {year}{" "}
                <a
                  href="https://www.augutsya.com/"
                  target="_blank"
                  rel="noreferrer"
                  className="ftLink"
                >
                  Augutsya.com
                </a>
                . All rights reserved.
              </p>
              <div className="ftBottom__stats">
                <span className="stat-item">
                  <span className="stat-icon">👁️</span>
                  Visitors: {visitorCount.toLocaleString()}
                </span>
              </div>
            </div>

            <div className="ftBottom__right">
              <div className="ftContactInfo">
                <div className="contact-item">
                  <span className="ico ico--phone" aria-hidden="true" />
                  <a href="tel:+919811475754" className="ftLink">
                    +91 98114 75754
                  </a>
                </div>
                <div className="contact-item">
                  <span className="ico ico--mail" aria-hidden="true" />
                  <a href="mailto:contact-us@augutsya.com" className="ftLink">
                    contact-us@augutsya.com
                  </a>
                </div>
              </div>

              <button
                className="toTop"
                aria-label="Back to top"
                onClick={handleScrollToTop}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
                  <path fill="currentColor" d="M12 5l7 7-1.4 1.4L13 8.8V20h-2V8.8L6.4 13.4 5 12z" />
                </svg>
                <span className="toTop__text">Top</span>
              </button>
            </div>
          </div>
          
        </Container>
      </div>
    </footer>
  );
}
